<template>
    <section class="gallery">
        <div class="container">
            <div class="gallery__row gallery__row--tabs">
                <div class="tabs">
                    <a :key="collection.id" v-for="collection in collections" href="/" class="tabs__item" :class="{'tabs__item--active': (collection.id == selectedCollectionId)}" @click.prevent="setSelectedCollection(collection.id)">{{ collection.heading }}</a>
                </div>
            </div>
            <gallery-collection :key="collection.id" v-for="collection in collections" :collection="collection" v-show="collection.id == selectedCollectionId" />
        </div>
    </section>
</template>
<script>
import GalleryCollection from './GalleryCollection.vue'
import { EventBus } from './EventBus'

export default {
    props: {
		collections: Array
    },
    components: {
        galleryCollection : GalleryCollection
    },
	data() {
		return {
            selectedCollectionId: {
                type: Number,
                default: null
            }
        };	
	},
    created: function () {
        this.selectedCollectionId = this.collections[0].id
    },
    methods: {
        setSelectedCollection(id) {
            this.selectedCollectionId = id
            EventBus.$emit('gallery-changed')
        }
    }
}
</script>
